//这里是 项目管理 模块的路由文件

const basePath = "/admin/project/";
export default [
    //项目列表
    {
        path: `${basePath}list`,
        name: 'ProjectList',
        component: r => require.ensure([], () => r(require('@/views/project/ProjectList')), 'Project')
    },
    //项目详情
    {
        path: `${basePath}description`,
        name: 'ProjectDescription',
        component: r => require.ensure([], () => r(require('@/views/project/ProjectDescription')), 'Project')
    },
    //项目创建
    {
        path: `${basePath}create`,
        name: 'ProjectCreate',
        component: r => require.ensure([], () => r(require('@/views/project/ProjectCreate')), 'Project')
    },
    //项目任务管理
    {
        path: `${basePath}task`,
        name: 'ProjectTask',
        component: r => require.ensure([], () => r(require('@/views/project/ProjectTask')), 'Project')
    }
]
